import endpoint from "../../config/endpoints";

export const EncashedLeaveProcessJson = {
    showSaveNextBtn: true,
    formPath: "/holiday-structure-form",
    apiBaseURL: endpoint.encashedLeaveHeader,
    changeExcel: endpoint.exportData,
    screenTitle: "Encashed Leave Process",
    showAddButton: true,
    showPdfDownload: true,
    pdfFileName: "Holiday Structure",
    showExcelDownload: true,
    excelFileName: "Holiday Structure",
    formPathView: "/encashed-leave-view",
    isActiveURL: endpoint.holidayStructureHeader + "/update-is-active",
    openFormPathStatus: "/encashed-leave-assignation",


    tableColumnsToFilter: [
        {
            columnDisplayName: "Emp Code",
            columnKeyName: "empCode",
            isChecked: true,
        },
        {
            columnDisplayName: "Sales Team Name",
            columnKeyName: "salesTeamName",
            isChecked: true,
        },
        {
            columnDisplayName: "Sales Team Type",
            columnKeyName: "salesTeamType",
            isChecked: true,
        },
        {
            columnDisplayName: "Reporting Type",
            columnKeyName: "reportingManagerType",
            isChecked: true,
        },
        {
            columnDisplayName: "Reporting Name",
            columnKeyName: "reportingManagerName",
            isChecked: true,
        },
    ],
    fieldMeta: [
        {
            label: "Leave Year",
            controlType: "autocomplete",
            placeHolder: "Select Leave Year",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "leaveYearMasterDetail",
            dataKey: "leaveYearId",
            getListId: "leaveYearId",
            isRootLevelKey: true,
            isMandatory: true,
        },
    ],
};
